import { apiUrlProductQA } from "~constants";
import Network from "~helpers/Network";

import * as at from "./actionTypes";

export const fetchProductQuestions = (projectId, params) => async (dispatch) => {
  const response = await Network.request(apiUrlProductQA.getQuestions.format(projectId), { params });
  dispatch({ type: at.FETCH_PRODUCT_QUESTIONS, payload: response });
  return response;
};

export const addProductQuestion = (projectId, data) => async () => {
  return Network.request(apiUrlProductQA.getQuestions.format(projectId), {
    method: "POST",
    data,
    successMsg: true,
  });
};

export const updateProductQuestion = (projectId, id, data) => async () => {
  return Network.request(`${apiUrlProductQA.getQuestions.format(projectId)}${id}/`, {
    method: "PUT",
    data,
    successMsg: true,
  });
};

export const deleteProductQuestion = (projectId, id) => async () => {
  return Network.request(`${apiUrlProductQA.getQuestions.format(projectId)}${id}/`, {
    method: "DELETE",
    successMsg: true,
  });
};

export const fetchProductList = (projectId, searchText, signal) => async () => {
  const response = await Network.request(apiUrlProductQA.getProduct.format(projectId), {
    params: { title__icontains: searchText },
    signal,
  });
  return response;
};

export const fetchDirectoryList = (projectId, searchText, signal) => async () => {
  const response = await Network.request(apiUrlProductQA.getDirectory.format(projectId), {
    params: { search: searchText },
    signal,
  });
  return response;
};

export const fetchSingleProduct = (projectId, productId, options) => async () => {
  const response = await Network.request(`${apiUrlProductQA.getProduct.format(projectId)}${productId}/`, options);
  return response;
};

export const fetchSingleDirectory = (projectId, directoryId, options) => async () => {
  const response = await Network.request(`${apiUrlProductQA.getDirectory.format(projectId)}${directoryId}/`, options);
  return response;
};
